require('./sync-order-toast.scss');

const React = require('react');
const classnames = require('classnames');
import HttpsProtocolImage from '../../component/common/https-protocol-image';
const loginUrl = require('../../asset/images/login.svg');
const orderSuccessUrl = require('../../asset/images/order_success.svg');
const personDefaultImageUrl = require('../../asset/images/person-default.svg');

module.exports = React.createClass({
  displayName: 'SyncOrderToast',
  propTypes: {
    toastProps:React.PropTypes.object,
    onCloseWindow:React.PropTypes.func.isRequired,
  },
  getInitialState() {
    return {
      imgStyle:{
      },
      buttonPropStyle:{
      },
      contentStyle:null,
    };
  },
  componentDidMount() {
  },
  componentWillReceiveProps(newProps) {
  },
  buildImgProp(data) {
    let imgUrl = null;
    if (!data) {
      return personDefaultImageUrl;
    }

    if (data === 'login') {
      imgUrl = loginUrl;
    } else if (data === 'order_success') {
      imgUrl = orderSuccessUrl;
    } else {
      // 默认用户头像地址
      imgUrl = data;
    }
    return imgUrl;
  },
  handleModalTouchTap(evt) {
    if (evt) {
      evt.preventDefault();
    }

    this.props.onCloseWindow();
  },
  handleBtnTouchTap(evt) {
    if (evt) {
      evt.preventDefault();
    }

    const { toastProps } = this.props;
    if (toastProps.onBtnTap) {
      toastProps.onBtnTap();
    }
  },
  render() {
    const { toastProps } = this.props;
    const { buttonProp } = toastProps || {};
    const { imgStyle, buttonPropStyle } = this.state;
    const classNames = `sync-order-toast ${toastProps.className || ''}`.trim();

    return (
      <div className={classNames} style={this.state.contentStyle}>
        <div className="sync-order-toast-back" onTouchTap={this.handleModalTouchTap}></div>
        <div className="sync-order-toast-content">
          <div className="sync-order-toast-body">
            <HttpsProtocolImage src={this.buildImgProp(toastProps.imgProp)} className="userPic" alt="头像" style={toastProps.imgStyle || imgStyle} />
            <p className="main-message">
              <span className="user-name">{toastProps.userName}</span>
              <span>{toastProps.mainMessage}</span>
            </p>
            <p className="vice-message">{toastProps.viceMessage}</p>
          </div>
          {
            buttonProp && buttonProp.text &&
              <div
                className={
                  classnames(
                    'sync-order-toast-btn',
                    buttonProp.className || '',
                    { 'right-button':toastProps.viceButtonProps }
                  )
                }
                onTouchTap={this.handleBtnTouchTap}
                style={buttonProp.style || buttonPropStyle}
              >
                {buttonProp.text}
              </div>
          }
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/sync-order-toast.jsx